import { useEffect, useMemo, useSyncExternalStore } from 'react'
import { klipPlayCountStore } from '@shared/stores/klipPlayCountStore'

export const useKlipPlayCounts = (actionCableUrl, {
    resourceType,
    resourceId,
    playCount,
}) => {
    useEffect(() => {
        klipPlayCountStore.seedInitialCounts({
            resourceType,
            resourceId,
            playCount,
        })
    }, [resourceType, resourceId, playCount])

    useEffect(() => {
        if (resourceId && resourceType) {
            return klipPlayCountStore.retainSubscription(actionCableUrl, resourceType)
        }

        return undefined
    }, [actionCableUrl, resourceId, resourceType])

    const snapshot = useSyncExternalStore(
        klipPlayCountStore.subscribe,
        klipPlayCountStore.getSnapshot,
    )

    const counts = useMemo(() => {
        const map = snapshot[resourceType]
        return {
            playCount: map.get(resourceId),
        }
    }, [snapshot, resourceType, resourceId])

    return {
        playCount: counts.playCount || playCount,
        subscribed: klipPlayCountStore.isConnected(actionCableUrl, resourceType),
    }
}
